'use strict';

let venmoExpressCheckoutInstance;

/**
 * Initiates the VENMO functionality on the express checkout pages
 * @param {boolean} isMiniCart Whether is mini cart page flow or not
 */
async function init(isMiniCart) {
    const VenmoExpressCheckout = require('../models/venmoExpressCheckout');
    const ProductPage = require('../models/productPage');

    const isProductPage = Boolean(document.querySelector('.js-pdp-venmo-btn-wrap, .js-pvp-venmo-btn-wrap'));

    venmoExpressCheckoutInstance = isProductPage && !isMiniCart ? new ProductPage() : new VenmoExpressCheckout();

    await venmoExpressCheckoutInstance.init();
}

async function processExpressCheckoutFlow(payload) {
    await venmoExpressCheckoutInstance.processPayment(payload);
}

/**
 * Inits Venmo MiniCart functionality on Storefront
 */
async function initVenmoOnMiniCartFunctionality() {
    const minicartPopoverEl = document.querySelector('.minicart .popover');

    if (!minicartPopoverEl) {
        return;
    }

    const generalButtonDisplayBehavior = require('../../generalButtonDisplayBehavior');

    // Case when buyer remove product from the Cart
    $('body').on('cart:update', function() {
        const venmoMiniCartButton = document.querySelector('.js-braintree-minicart-venmo-button');

        if (venmoMiniCartButton) {
            generalButtonDisplayBehavior.minicartButtonBehavior(venmoMiniCartButton);
        }
    });

    const helper = require('../../helper');
    const venmoBusinessLogic = require('../venmo');

    const MAX_ADDED_NODES = 2;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach(async(mutation) => {
            const venmoMiniCartButton = document.querySelector('.js-braintree-minicart-venmo-button');

            if ((mutation.addedNodes.length < MAX_ADDED_NODES) || !venmoMiniCartButton) {
                return;
            }

            const isVenmoButtonInited = helper.tryParseJSON(venmoMiniCartButton?.getAttribute('data-is-inited'));
            const zeroProductPrice = generalButtonDisplayBehavior.isCurrentTotalBasketPriceZero();

            if (Boolean(venmoMiniCartButton) && !isVenmoButtonInited && !zeroProductPrice) {
                const isMiniCart = true;

                venmoMiniCartButton.setAttribute('data-is-inited', true);
                await venmoBusinessLogic.initExpressCheckout(isMiniCart);
            }
        });
    });

    observer.observe(minicartPopoverEl, { childList: true });
}

module.exports = {
    init,
    processExpressCheckoutFlow,
    initVenmoOnMiniCartFunctionality
};
